import React from "react";
import { clsx } from "clsx";
import { StyledContainer } from "../../Styled/Container";
import { type SellingPointsOutputProps } from "./withSellingPoints";

const Container = (props: any) => (
  <StyledContainer
    {...props}
    className={clsx(props.className, "pb-mega md:pb-tera")}
  />
);

const Wrapper = (props: any) => (
  <div
    {...props}
    className={clsx(props.className, "flex flex-col xl:-mx-maxi xl:flex-row")}
  />
);

const Desktop = (props: any) => (
  <div
    {...props}
    className={clsx(props.className, "relative mx-maxi hidden w-full xl:block")}
  />
);

const Mobile = (props: any) => (
  <div {...props} className={clsx(props.className, "block xl:hidden")} />
);

const CircleWrapper = (props: any) => (
  <div {...props} className={clsx(props.className, "aspect-square relative")} />
);

const Circle = (props: any) => (
  <div
    {...props}
    className={clsx(
      props.className,
      "inset-0 border-green bg-green absolute rounded-full px-mega py-giga",
    )}
  />
);

const Point = (props: any) => (
  <div
    {...props}
    className={clsx(props.className, "flex w-full flex-wrap pb-midi")}
  />
);

const Title = (props: any) => (
  <h3
    {...props}
    className={clsx(
      props.className,
      "block w-full text-left font-display text-h2 leading-h3 md:mb-mini md:text-[32px] md:leading-h4 xl:text-center",
    )}
  />
);

const Description = (props: any) => (
  <p
    {...props}
    className={clsx(
      props.className,
      "block w-full text-left text-body leading-body md:px-pico xl:text-center",
    )}
  />
);

const SellingPointsCircles = ({
  points,
  width,
}: Partial<SellingPointsOutputProps>) => {
  if (!points?.length) {
    return null;
  }

  return (
    <Container width={width} data-testid="selling-points-circles">
      <Wrapper>
        {points.map(({ title, description }) => (
          <React.Fragment key={title}>
            <Desktop>
              <CircleWrapper>
                <Circle>
                  <Point>
                    <Title>{title}</Title>
                    <Description>{description}</Description>
                  </Point>
                </Circle>
              </CircleWrapper>
            </Desktop>
            <Mobile>
              <Point>
                <Title>{title}</Title>
                <Description>{description}</Description>
              </Point>
            </Mobile>
          </React.Fragment>
        ))}
      </Wrapper>
    </Container>
  );
};

export default SellingPointsCircles;
